import React from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import useTitle from "../components/Title";
import ReportContent from "../components/ReportContent";
import SupportContent from "../components/SupportContent";
import { Link } from "react-router-dom";

const AdminReports = () => {
  useTitle("- Admin Reports");

  return (
    <div className="">
      <Navbar />
      <div className="App-header mt-4">
        <div className="container-md">
          
            <div className="row justify-content-between align-items-center mb-5">
               <div className="col-auto">
                  <h1 className="mt-5 event-heading-start">Secret Admin page of doom.</h1>
                  <p className="event-sub-text mb-5"> Create a new Article and see all latest issues.</p>
                </div>
                <div className="col-auto">
                  <Link to="/NewsAdmin" className="btn btn-primary"> New Article </Link>
                </div>
            </div>

              <div className="row justify-content-between filter-section mx-0 align-items-end"></div>

              <ReportContent />

              <div className="row justify-content-between filter-section mx-0 align-items-end"></div>

            <SupportContent />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AdminReports;
